const SectionHeader = ({ tagline, title }) => {
  return (
    <>
      <div className="flex justify-start gap-1 items-center align-middle mb-2">
        <div className="h-0 border-t-2 border-red-500 w-[10%] " />
        <p className="text-red-500 font-medium ">{tagline}</p>
      </div>
      <h2 className="text-4xl font-bold text-navy-900">{title}</h2>
    </>
  );
};

export default SectionHeader;
